import React from 'react';
import { StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

export const PropertiesScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <SkeletonList count={6} gap={8}>
      <SkeletonListItem
        avatar
        avatarSize={32}
        lines={2}
        lineWidths={['70%', '50%']}
      />
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 12,
  },
});
